export type VoiceAppKey = "policy" | "supportpop" | "lipione" | "jarvisone" | "contract";

export const VOICE_APP_SELECTION_MESSAGE = "Coming Soon!";

export const VOICE_ACCESS_REQUIRED_MESSAGE = "Access required";

export function isLipiFamilyVoiceAppKey(appKey?: VoiceAppKey | null): boolean {
  return appKey === "lipione" || appKey === "jarvisone";
}

export function normalizeVoiceAppKey(appName?: string | null): VoiceAppKey | null {
  const normalized = (appName || "").trim().toLowerCase();
  const compact = normalized.replace(/[^a-z0-9]/g, "");

  if (!normalized) return null;
  if (
    normalized.includes("policy") ||
    normalized.includes("policybuddy") ||
    normalized.includes("privacypolicybot") ||
    compact.includes("policybuddy") ||
    compact.includes("privacypolicybot")
  ) {
    return "policy";
  }
  if (
    normalized.includes("supportpop") ||
    normalized.includes("support pop") ||
    normalized.includes("lipisupport") ||
    compact.includes("supportpop") ||
    compact.includes("lipisupport")
  ) {
    return "supportpop";
  }
  if (
    normalized.includes("jarvisone") ||
    normalized.includes("jarvis one") ||
    compact.includes("jarvisone")
  ) {
    return "jarvisone";
  }
  if (
    normalized.includes("lipione") ||
    normalized.includes("lipi one") ||
    compact.includes("lipione")
  ) {
    return "lipione";
  }
  if (
    normalized.includes("contract") ||
    normalized.includes("contractbuddy") ||
    normalized.includes("lipicontract") ||
    compact.includes("contractbuddy") ||
    compact.includes("lipicontract")
  ) {
    return "contract";
  }

  return null;
}

export function isVoiceAppEnabled(appName?: string | null): boolean {
  return normalizeVoiceAppKey(appName) !== null;
}
